import { render, staticRenderFns } from "./AbsenceContentComponent.vue?vue&type=template&id=25767168&scoped=true&"
import script from "./AbsenceContentComponent.vue?vue&type=script&lang=js&"
export * from "./AbsenceContentComponent.vue?vue&type=script&lang=js&"
import style0 from "./AbsenceContentComponent.vue?vue&type=style&index=0&id=25767168&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25767168",
  null
  
)

export default component.exports